<template>
	<div>
		<h1>Ki- és belépések naplója</h1>
		<v-row>
      <v-col cols="12" sm="6">
        <v-select
          label="Tanuló"
          v-model="tanulo"
          prepend-inner-icon="fa-user"
          :items="tanulok"
          item-text="nev"
          item-value="id"
          @change="tablazatfrissitese()">
            <template v-slot:item="{item}">
              <span>{{item.nev+(item.csoportnev? " - "+item.csoportnev+" ("+item.csoportvezeto+")":"")+" - "+item.minositesnev}}</span>
            </template>
        </v-select>
      </v-col>
			<v-col cols="12" sm="6">
				<v-menu
          v-if="tanulo>-1"
		      v-model="datumvalaszto.menu"
		      :close-on-content-click="false"
		      transition="scale-transition"
		      offset-y
		      min-width="290px"
		    >
		      <template v-slot:activator="{ on, attrs }">
		        <v-text-field
		          v-model="datumvalaszto.datum"
		          label="Dátum"
		          prepend-inner-icon="fa-calendar"
		          readonly
		          v-bind="attrs"
		          v-on="on"
		        ></v-text-field>
		      </template>
		      <v-date-picker
		        v-model="datumvalaszto.datum"
		        no-title
		        scrollable
						first-day-of-week="1"
						@input="datumvalaszto.menu=false, tablazatfrissitese()"
		      >
		      </v-date-picker>
		    </v-menu>
			</v-col>
		</v-row>
		<v-data-table

			:headers="tablazat.fejlecek"
			:items="kiesbelepesek"
			sort-by="szam"
      hide-default-footer
      disable-pagination
		>
		</v-data-table>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
	export default {
		data: function(){
			return {
				datumvalaszto: {
					menu: false,
					datum: (new Date()).toISOString().substring(0,10)
				},
        tanulo: -1,
				snackbar: {
					megnyit: false,
					szoveg: ""
				},
				tablazat: {
          mutat: true,
					fejlecek: [
						{
							text: "Állomás",
							value: "allomasnev",
							align: "center",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Időpont",
							value: "idopont",
							align: "left",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Irány",
							value: "irany",
							align: "left",
							sortable: false,
							filterable: false,
							groupable: false
						},
					]
				},
        tanulok: [],
				kiesbelepesek: []
			}
		},
		computed: {

		},
		watch: {

		},
		methods: {
			tablazatfrissitese: function() {
        return new Promise((ok,nemok) => {
          this.axios.get(this.$store.state.backendeleres+"kiesbelepesek/egydiak/"+this.tanulo+"/"+this.datumvalaszto.datum)
                    .then((response) => {
                      if(response.data.bejelentkezve==false) this.kijelentkezes();
                      if(response.data.ok){
                         this.kiesbelepesek=response.data.kiesbelepesek;
                       }
                      ok();
                    })
        })
			}
		},
		mounted(){
        this.axios.get(this.$store.state.backendeleres+"kiesbelepesek/tanulok").then((response) => {
          if(response.data.bejelentkezve==false) this.kijelentkezes();
          if(response.data.ok) this.tanulok=response.data.tanulok;
        })
		}
	}
</script>
